module.exports = __webpack_public_path__ + "static/media/3.12d325ab.jpg";